

import React, { useRef, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import './Textarea.scss'

interface Props {
  value: string
  onChange: (value: string) => void
  onStartEditing?: () => void
  placeholder: string
  delay?: number
  style?: any
}

const Textarea = (props: Props) => {

  const {
    value,
    onChange,
    onStartEditing,
    placeholder,
    delay = 1000,
    style,
  } = props

  const lastSent = useRef<string>(value)

  const [internalValue, setInternalValue] = useState(value)

  useEffect(() => {
    setInternalValue(value)
  }, [value])

  useEffect(() => {
    const handler = setTimeout(() => {
      if (internalValue !== lastSent.current) {
        onChange(internalValue)
        lastSent.current = internalValue
      }
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [internalValue, delay])

  return (
    <textarea
      value={internalValue}
      onChange={(e) => {
        if (onStartEditing) onStartEditing()
        setInternalValue(e.target.value)
      }}
      placeholder={placeholder}
      className='textarea'
      rows={3}
      style={{
        minHeight: 60,
        ...style,
      }}
    />
  )
}

export default Textarea
